/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `manual` - Manuală
 * * `automatic` - Automată
 * * `cvt` - CVT
 * * `semi_automatic` - Semi-automată
 */
export enum TransmissionTypeEnum {
  MANUAL = 'manual',
  AUTOMATIC = 'automatic',
  CVT = 'cvt',
  SEMI_AUTOMATIC = 'semi_automatic',
}
